
export function localeDateTimeFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}


export function localeDateFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    }).format(played)

    return formated;
}


export function localeShortFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('en-us', {
        month: 'long',
        day: 'numeric',
    }).format(played)

    return formated;
}